import { ListProvider } from "./list-provider";
import { JobStatus } from "../../../../business-objects/job-status/job-status.model";
import { JobStatusStoreFacade } from "../../../../business-objects/job-status/job-status.store-facade";

export class JobStatusListProvider extends ListProvider<JobStatus> {

    getFacade(): JobStatusStoreFacade {
        return this.appFacade.objects.jobStatus.store;
    }

    getPrimaryField(item: JobStatus): string {
        return item && item.title;
    }

    getSecondaryField(item: JobStatus): string {
        return item && item.title;
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/list-picker/form/list-providers/job-status-list-provider.ts